import APIClient from './APIClient';

const {
  REACT_APP_ONBOARDING_API_HOST: ONBOARDING_API_HOST,
  REACT_APP_ZENDESK_TOKEN_ENDPOINT: ZENDESK_TOKEN_ENDPOINT,
} = process.env;

export const urlFor = customerId =>
  `${ONBOARDING_API_HOST}${ZENDESK_TOKEN_ENDPOINT}`.replace('{customerId}', customerId);

export default class ZendeskTokenAPI {
  static getZendeskToken = (customerId, token, email) =>
    APIClient.get(urlFor(customerId), token, { params: { email } }).then(response => {
      const { data } = response;
      const { token, widget_token: widgetToken } = data;

      return { token, widgetToken };
    });
}
